var Handlebars = require('/src/melia-widget/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(helpers.transportModeActive || (depth0 && depth0.transportModeActive) || helpers.helperMissing).call(alias1,depth0,(depths[1] != null ? depths[1].activeTransportType : depths[1]),{"name":"transportModeActive","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var helper, alias1=container.lambda, alias2=container.escapeExpression;

  return "            <div data-transportMode=\""
    + alias2(alias1(depth0, depth0))
    + "\"\n                 class=\"melia-jp-transportmode lmm-icon-"
    + alias2(alias1(depth0, depth0))
    + " "
    + alias2(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"componentClass","hash":{},"data":data}) : helper)))
    + " active\"></div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, alias1=container.lambda, alias2=container.escapeExpression;

  return "            <div data-transportMode=\""
    + alias2(alias1(depth0, depth0))
    + "\"\n                 class=\"melia-jp-transportmode lmm-icon-"
    + alias2(alias1(depth0, depth0))
    + " "
    + alias2(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.transportTypes : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true,"useDepths":true});


//////////////////
// WEBPACK FOOTER
// ./src/components/transportModes/transportModes.hbs
// module id = 162
// module chunks = 1